// extracted by mini-css-extract-plugin
export default {"entityCard":"RecentAccess_entityCard__E+2YV","avatar":"RecentAccess_avatar__-sEpd"};